<template>
  <div class="entry-info">
    <div class="title-info" v-if="project.unionMatchId">
      <div class="title-info-logo">
        <img :src="imageView(match.icon)" alt="" />
      </div>
      <div class="title-info-right">
        <div class="row row-name">{{ match.chineseName || match.unionMatchName || '-' }}</div>
        <div class="row row-group">组别：{{ project.matchGroupName || '-' }}</div>
        <div class="row row-count">
          允许人数：队员{{ project.teamMemberLeastCount ?? 0 }}-{{ project.teamMemberLimitCount ?? 0 }}人
          <template v-if="hasOfficer"> 工作组：{{ project.minOffice ?? 0 }}～{{ project.maxOffice ?? 0 }}</template>
        </div>
        <div class="row" v-if="project.isOpenAgeLimit === 1">
          允许年龄：{{ allowedAgeText }}
        </div>
        <div class="row row-fee" v-if="project.feeMethod !== 0">
          收费方式：{{ getFeeMethodsLabel(project.feeMethod) }} 金额：{{ project.feeAmount != null ? (project.feeAmount / 100).toFixed(2) : '0.00' }}元/{{ project.feeMethod === 2 ? '队' : '人' }}
        </div>
      </div>
    </div>
    <!-- 报名须知：开启时展示(1=必须阅读 2=非必须)，点击打开弹框 -->
    <div
      v-if="(project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) && signupInstructions"
      class="signup-notice-bar"
      @click="signupInstructionsOpen = true"
    >
      <van-icon name="volume-o" class="notice-icon" />
      <span class="notice-text" :title="signupInstructionsText">{{ signupInstructionsText || '报名须知' }}</span>
      <span class="notice-link">查看详情 &gt;</span>
    </div>
    <!-- 仅限年度注册：选择已有注册球队报名 -->
    <template v-if="project.publicSignUp === 2">
      <!-- 选择球队前：仅展示参赛球队 + 选择按钮 -->
      <div v-if="!orgTeamId" class="register">
        <div class="choice-team">
          <div class="title">参赛球队</div>
          <div class="choice-btn" @click="goSelectTeamList">+选择球队</div>
        </div>
      </div>
      <!-- 选择球队后：用表单组件回显，标题为「参赛球队」、右侧「重选球队」 -->
      <entry-info-team-form
        v-if="orgTeamId"
        ref="teamForm"
        title-text="参赛球队"
        :show-reselect-button="false"
        :show-selected-team-info="true"
        :hidden-fields="['name','contactPerson','contactNumber','badge']"
        :team="team"
        :team-checkboxes="teamCheckboxes"
        :clothes="clothes"
        :team-color="teamColor"
        :team-signup-fields-label="teamSignupFieldsLabel"
        :team-id="teamId"
        @reselect="goSelectTeamList"
        @open-delegation="showDelegation = true"
        @open-home-color="showHomeColorFun"
        @open-away-color="showAwayColorFun"
        @upload-badge="uploadBadge"
        @delete-badge="deleteBadge"
        @upload-file="uploadFile"
        @delete-file="deleteFile"
        @preview-clothes="previewImg"
        @choose-clothes="chooseClothes"
      />
    </template>
    <!-- 非仅限年度注册：填写队伍信息表单 -->
    <entry-info-team-form
      v-else
      ref="teamForm"
      :team="team"
      :team-checkboxes="teamCheckboxes"
      :clothes="clothes"
      :team-color="teamColor"
      :team-signup-fields-label="teamSignupFieldsLabel"
      :team-id="teamId"
      @open-delegation="showDelegation = true"
      @open-home-color="showHomeColorFun"
      @open-away-color="showAwayColorFun"
      @upload-badge="uploadBadge"
      @delete-badge="deleteBadge"
      @upload-file="uploadFile"
      @delete-file="deleteFile"
      @preview-clothes="previewImg"
      @choose-clothes="chooseClothes"
    />
    <!-- 底部说明：GetBMMatchTeamSignup 返回的 signupExplanation，key 可能不存在 -->
    <div v-if="project.signupExplanation" class="bottom-explanation">
      <div class="bottom-explanation-title">说明</div>
      <div class="bottom-explanation-content" v-html="signupExplanationHtml"></div>
    </div>
    <div class="bottom">
      <div @click="showAgreementFun" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
        style="display: flex; justify-content: center; padding: 0 0 8px 0">
        <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
          <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
          <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
          }}》</span>
        </van-checkbox>
      </div>
      <template v-if="project.publicSignUp === 2">
        <van-button v-if="orgTeamId" type="info" block @click="signupByOrgTeam"
          :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }" style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px">确认报名</van-button>
        <van-button v-else type="info" block disabled
          style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px; opacity: 0.6">请先选择球队</van-button>
      </template>
      <template v-else>
        <van-button type="info" block @click="updateTeam" v-if="teamId"
          :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }" style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px">保 存</van-button>
        <van-button type="info" block @click="createTeam" v-else
          :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }" style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px">创建球队</van-button>
      </template>
    </div>
    <van-popup v-model="showAwayColor" position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择客队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmAwayColor"
        @cancel="onCancelAwayColor">
        <template #option="option">
          <div style="display: flex; align-items: center">
            <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
            <span>{{ option.label }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showHomeColor" position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择主队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmHomeColor"
        @cancel="onCancelHomeColor">
        <template #option="option">
          <div style="display: flex; align-items: center">
            <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
            <span>{{ option.label }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
      <div id="agreement"></div>
      <div style="height: 115px;"></div>
      <div class="bottom">
        <van-button type="info" block @click="allowAgreement"
          style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showDelegation" position="bottom" :style="{ height: '50%' }">
      <van-picker title="代表团" show-toolbar :columns="delegationList" @confirm="onConfirm"
        @cancel="showDelegation = false" />
    </van-popup>
    <van-popup v-model="signupInstructionsOpen" :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }">
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" @click="signupInstructionsOpen = false">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Form,
  Field,
  Button,
  Popup,
  Checkbox,
  Uploader,
  Picker,
  Dialog,
  Icon,
  Image as VanImage,
  ImagePreview,
  Toast
} from "vant";
Vue.use(Form).use(Field).use(Button).use(Popup).use(Checkbox).use(Uploader).use(Picker).use(Dialog).use(Icon).use(VanImage).use(ImagePreview)
import { getPassport } from '@/libs/passport'
import { createBMMatchTeam, getAreaTreeList, getBMMatchTeamSignup, getBMUnionMatch, updateBMMatchTeam, getOrgTeamDetail, signupBMMatchByTeam } from '@/api/match'
import EntryInfoTeamForm from './entry-info-team-form.vue'
import { DateUtil, QNImageUtil, RegExpr } from "@/utils";
import { getQiniuUploadToken, uploadImage } from "@/api/qiniu";
import { feeMethodOptions } from "@/config";

const clothesColor = [
  { value: '1', label: '白色', img: require('../../../assets/jersey-color/qy_1.png') },
  { value: '2', label: '蓝色', img: require('../../../assets/jersey-color/qy_2.png') },
  { value: '3', label: '暗红', img: require('../../../assets/jersey-color/qy_3.png') },
  { value: '4', label: '深黄', img: require('../../../assets/jersey-color/qy_4.png') },
  { value: '5', label: '绿色', img: require('../../../assets/jersey-color/qy_5.png') },
  { value: '6', label: '紫色', img: require('../../../assets/jersey-color/qy_6.png') },
  { value: '7', label: '橙色', img: require('../../../assets/jersey-color/qy_7.png') },
  { value: '8', label: '黑色', img: require('../../../assets/jersey-color/qy_8.png') },
  { value: '9', label: '白底黑条纹', img: require('../../../assets/jersey-color/qy_9.png') },
  { value: '10', label: '紫底黑条纹', img: require('../../../assets/jersey-color/qy_10.png') },
  { value: '11', label: '白底红条纹', img: require('../../../assets/jersey-color/qy_11.png') },
  { value: '12', label: '红底黑条纹', img: require('../../../assets/jersey-color/qy_12.png') },
  { value: '13', label: '黄底红条纹', img: require('../../../assets/jersey-color/qy_13.png') },
  { value: '14', label: '红底紫条纹', img: require('../../../assets/jersey-color/qy_14.png') },
  { value: '15', label: '白底蓝条纹', img: require('../../../assets/jersey-color/qy_15.png') },
  { value: '16', label: '黄底绿条纹', img: require('../../../assets/jersey-color/qy_16.png') },
  { value: '17', label: '白底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_17.png') },
  { value: '18', label: '白底红条纹（竖）', img: require('../../../assets/jersey-color/qy_18.png') },
  { value: '19', label: '白底黄条纹（竖）', img: require('../../../assets/jersey-color/qy_19.png') },
  { value: '20', label: '白底蓝条纹（竖）', img: require('../../../assets/jersey-color/qy_20.png') },
  { value: '21', label: '红底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_21.png') },
  { value: '22', label: '红底紫条纹（竖）', img: require('../../../assets/jersey-color/qy_22.png') },
  { value: '23', label: '黄底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_23.png') },
  { value: '24', label: '黄底绿条纹（竖）', img: require('../../../assets/jersey-color/qy_24.png') },
  { value: '25', label: '粉红', img: require('../../../assets/jersey-color/qy_25.png') },
  { value: '26', label: '天蓝', img: require('../../../assets/jersey-color/qy_26.png') },
  { value: '27', label: '浅黄', img: require('../../../assets/jersey-color/qy_27.png') }
]

const defaultTeam = {
  name: '',
  contactPerson: '',
  contactNumber: '',
  badge: '',
  badgeList: [],
  summary: '',
  homeClothesColor: '',
  awayClothesColor: '',
  delegation: '',
  insurancePolicy: '',
  insurancePolicyList: []
}

export default {
  data() {
    return {
      clothes: [],
      project: {},
      team: {},
      showAwayColor: false,
      showHomeColor: false,
      teamCheckboxes: {},
      clothesColor: clothesColor,
      minDate: '',
      maxDate: '',
      allow: false,
      agreementList: [],
      showAgreement: false,
      title: '',
      projectId: '',
      unionMatchId: '',
      teamColor: {
        home: {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: ''
        },
        away: {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: ''
        }
      },
      showDelegation: false,
      delegationList: [],
      signupInstructionsOpen: false,
      signupInstructions: '',
      match: {},
      teamId: '',
      teamSignupFieldsLabel: {
        insurancePolicy: '参赛资料'
      },
      jetlympic: false,
      orgTeamId: '', // 注册期内球队注册ID（选择已有球队报名时使用）
      orgTeamDetail: null   // 机构球队详情（回填展示）
    }
  },
  computed: {
    /** 底部说明 HTML：处理接口返回中的 \n 为换行 */
    signupExplanationHtml() {
      const text = (this.project && this.project.signupExplanation) || ''
      // 将 \n 转为 <br>，避免直接 v-html 时丢失换行
      return text ? text.replace(/\n/g, '<br/>') : ''
    },
    hasOfficer() {
      const fs = this.project && this.project.teamSignupFields
      return typeof fs === 'string' && fs.indexOf('officer') !== -1
    },
    allowedAgeText() {
      const p = this.project
      if (!p) return ''
      const max = p.maxAge ? this.getFormatDate(p.maxAge) : ''
      const min = p.minAge ? this.getFormatDate(p.minAge) : ''
      if (max && min) return max + '～' + min
      if (min) return '晚于' + min
      if (max) return '早于' + max
      return ''
    },
    /** 报名须知纯文本（用于横幅一行展示，strip HTML） */
    signupInstructionsText() {
      if (!this.signupInstructions) return ''
      const div = document.createElement('div')
      div.innerHTML = this.signupInstructions
      return (div.textContent || div.innerText || '').trim()
    }
  },
  components: { EntryInfoTeamForm },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.getBMUnionMatch()
        this.getQiniuUploadToken()
      }
    })
  },
  activated() {
    if (this.project.publicSignUp === 2 && this.$route.query.orgTeamId && this.$route.query.orgTeamId !== this.orgTeamId) {
      this.orgTeamId = this.$route.query.orgTeamId
      this.fetchOrgTeamDetail()
    }
  },
  methods: {
    goSelectTeamList() {
      this.$router.push({
        path: '/entry-page/select-team-list',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.projectId,
          accountId: this.match.accountId
        }
      })
    },
    async fetchOrgTeamDetail() {
      const orgTeamId = this.$route.query.orgTeamId
      if (!orgTeamId || this.project.publicSignUp !== 2) return
      this.orgTeamId = orgTeamId
      try {
        const res = await getOrgTeamDetail(orgTeamId)
        const data = res && (res.data || res)
        this.orgTeamDetail = data
        this.mapOrgTeamDetailToTeam(data)
      } catch (e) {
        this.$toast.fail(e?.message || '获取球队详情失败')
        this.orgTeamDetail = null
      }
    },
    /** 将机构球队详情映射到 team/teamColor，供 entry-info-team-form 回显 */
    mapOrgTeamDetailToTeam(d) {
      if (!d) return
      const base = JSON.parse(JSON.stringify(defaultTeam))
      this.team = {
        ...base,
        name: d.name ?? d.teamName ?? base.name,
        teamAlias: d.teamAlias ?? d.shortName ?? '',
        manager: d.manager ?? '',
        contactPerson: d.contactPerson ?? '',
        contactNumber: d.contactNumber ?? '',
        badge: d.badge ?? d.logo ?? '',
        summary: d.summary ?? '',
        delegation: d.delegation ?? '',
        homeClothesColor: d.homeClothesColor ?? '',
        awayClothesColor: d.awayClothesColor ?? '',
        clothesId: d.clothesId ?? '',
        insurancePolicy: d.insurancePolicy ?? '',
        insurancePolicyList: d.insurancePolicy ? [{ url: this.imageView(d.insurancePolicy), isImage: false }] : []
      }
      this.team.badgeList = (this.team.badge ? [{ url: this.imageView(this.team.badge), isImage: true }] : [])
      this.team.homeClothesColorImg = this.findImg(this.team.homeClothesColor)
      this.team.awayClothesColorImg = this.findImg(this.team.awayClothesColor)
      if (d.clothesColorDescription && typeof d.clothesColorDescription === 'string') {
        const labelToKey = {
          '主场上衣': ['home', 'a'], '主场短裤': ['home', 'b'], '主场球袜': ['home', 'c'],
          '主场守门员上衣': ['home', 'd'], '主场守门员短裤': ['home', 'e'], '主场守门员球袜': ['home', 'f'], '主场替补背心': ['home', 'g'],
          '客场上衣': ['away', 'a'], '客场短裤': ['away', 'b'], '客场球袜': ['away', 'c'],
          '客场守门员上衣': ['away', 'd'], '客场守门员短裤': ['away', 'e'], '客场守门员球袜': ['away', 'f'], '客场替补背心': ['away', 'g']
        }
        try {
          d.clothesColorDescription.split(',').forEach(part => {
            const idx = part.indexOf(':')
            if (idx === -1) return
            const label = part.slice(0, idx).trim()
            const value = part.slice(idx + 1).trim()
            const pair = labelToKey[label]
            if (pair && value) {
              const [side, key] = pair
              this.$set(this.teamColor[side], key, value)
            }
          })
        } catch (e) {
          console.error(e)
        }
      }
    },
    signupByOrgTeam() {
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        this.showAgreementFun()
        Toast.fail('请先同意协议或条款')
        return
      }
      if (!this.orgTeamId) {
        Toast.fail('请先选择球队')
        return
      }
      this.showLoading = true
      const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        delete params.homeClothesColorImg
        delete params.awayClothesColorImg
        delete params.insurancePolicyList
        params.matchId = this.projectId
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},主场替补背心:${home.g},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f},客场替补背心:${away.g}`
        }
      signupBMMatchByTeam({
        unionMatchId: this.unionMatchId,
        matchId: this.projectId,
        teamId: this.orgTeamId,
        ...params
      }).then(res => {
        this.showLoading = false
        if (res) {
          Toast.success('报名成功')
          this.$router.push({ path: '/entry-page/team-operate', query: { unionMatchId: this.unionMatchId, matchId: this.projectId, teamId: this.orgTeamId, type: 'create-team-org' } })
        }
      }).catch(() => {
        this.showLoading = false
      })
    },
    onConfirm(e) {
      this.team.delegation = e
      this.showDelegation = false
    },
    regexTeamName(value) {
      const length = this.strLength(value)
      return length <= 12
    },
    regexName(value) {
      let regex = /^[A-Za-z\u4e00-\u9fa5\s]+$/
      return regex.test(value)
    },
    strLength(word) {
      let length = 0
      if (typeof word === 'number') {
        length = word.toString().length
      } else if (word === null) {
        length = 3
      } else if (typeof word === 'undefined') {
        length = 0
      } else {
        Array.from(word).map(function (char) {
          if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2
          } else {
            length++
          }
        })
      }
      return length
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    previewImg(img) {
      if (!img) return
      ImagePreview([
        this.imageView((this.getClothesImg(img)))
      ])
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    chooseClothes(item) {
      if (item.isChoosed === 1) return
      this.$set(this.team, 'clothesId', item.id)
    },
    getClothesImg(id) {
      const c = this.clothes.find(item => item.id === id)
      if (!c) return ''
      return c.image
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          this.getAreaTreeList()
        }
      })
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId,
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          const project = data.match
          if (project.teamSignupFieldsLabel) {
            this.teamSignupFieldsLabel = {
              ...this.teamSignupFieldsLabel,
              ...project.teamSignupFieldsLabel || {}
            }
          }
          this.agreementList = data.agreement || []
          this.clothes = data.clothes
          this.minDate = project.maxAge ? new Date(project.maxAge) : new Date(1970, 0, 1)
          this.maxDate = project.minAge ? new Date(project.minAge) : new Date()
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          const playerCheckboxes = {}
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.playerCheckboxes = playerCheckboxes
          const tsfs = project.teamSignupFields && project.teamSignupFields.split('|') || []
          const teamCheckboxes = {}
          tsfs.forEach(tsf => {
            teamCheckboxes[tsf] = true
          })
          this.teamCheckboxes = teamCheckboxes
          this.project = data.match
          if (this.project.publicSignUp === 2 && this.$route.query.orgTeamId) {
            this.orgTeamId = this.$route.query.orgTeamId
            this.fetchOrgTeamDetail()
          }
          if (data.team) {
            this.team = data.team
            this.team.badgeList = [{ url: this.imageView(data.team.badge), isImage: true }]
          } else {
            this.team = JSON.parse(JSON.stringify(defaultTeam))
            this.team.homeClothesColorImg = this.findImg(this.team.homeClothesColor)
            this.team.awayClothesColorImg = this.findImg(this.team.awayClothesColor)
          }

          if (data.match.teamDelegations) {
            this.delegationList = data.match.teamDelegations.split(',') || []
          }
          // signupInstructionsOpen: 0=未开启 1=开启且必须阅读 2=开启非必须阅读
          if (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) {
            this.signupInstructions = project.signupInstructions
          }
          if (project.signupInstructionsOpen === 1) {
            this.signupInstructionsOpen = true
          }
        }
      })
    },
    showAwayColorFun() {
      this.showAwayColor = true
    },
    showHomeColorFun() {
      this.showHomeColor = true
    },
    onConfirmHomeColor(value) {
      const team = JSON.parse(JSON.stringify(this.team))
      team.homeClothesColor = value.value
      team.homeClothesColorImg = value.img
      this.team = team
      this.showHomeColor = false
    },
    onCancelHomeColor() {
      this.showHomeColor = false
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    uploadBadge(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.$set(this.team,'badge',res.hash)
        this.$forceUpdate()
      })
    },
    uploadFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      const type = file.file.type.split('/')[1]
      uploadImage(formData).then(res => {
        const hash = res.hash + ',' + type
        this.team.insurancePolicy = hash
        this.$forceUpdate()
      })
    },
    deleteBadge() {
      const team = JSON.parse(JSON.stringify(this.team))
      team.badge = ''
      team.badgeList = []
      this.team = team
    },
    deleteFile() {
      const team = JSON.parse(JSON.stringify(this.team))
      team.insurancePolicy = ''
      team.insurancePolicyList = []
      this.team = team
    },
    createTeam() {
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        this.showAgreementFun()
        Toast.fail('请先同意协议或条款')
        return
      }
      const formRef = this.$refs.teamForm
      if (!formRef || !formRef.validate) return
      formRef.validate().then(() => {
        this.showLoading = true
        const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        delete params.homeClothesColorImg
        delete params.awayClothesColorImg
        delete params.insurancePolicyList
        params.matchId = this.projectId
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},主场替补背心:${home.g},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f},客场替补背心:${away.g}`
        }
        createBMMatchTeam(params).then(res => {
          if (res) {
            const teamId = res.data.id
            this.showLoading = false
            Dialog.alert({
              title: '球队创建成功',
              message: ''
            }).then(() => {
              this.$router.push({
                path: '/entry-page/entry-info',
                query: { unionMatchId: this.unionMatchId, matchId: this.projectId, teamId }
              })
            })
          } else {
            this.showLoading = false
          }
        })
      })
    },
    updateTeam() {
      const formRef = this.$refs.teamForm
      if (!formRef || !formRef.validate) return
      formRef.validate().then(() => { 
        const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f}`
        }
        params.matchId = this.projectId
        params.id = this.teamId
        updateBMMatchTeam(params).then(res => {
          if (res) {
            // this.getBMMatchTeamSignup()
            Toast.success('保存成功')
            this.$router.back()
          }
        })
      })
    },
    onConfirmAwayColor(value) {
      const team = JSON.parse(JSON.stringify(this.team))
      team.awayClothesColor = value.value
      team.awayClothesColorImg = value.img
      this.team = team
      this.showAwayColor = false
    },
    onCancelAwayColor() {
      this.showAwayColor = false
    },
    findImg(colorIndex) {
      const clothes = clothesColor.find(item => item.value === colorIndex)
      if (clothes) {
        return clothes.img
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-info {
  min-height: 100vh;
  background-color: rgb(246, 246, 248);
    padding-bottom: 120px;
box-sizing: border-box;
  .project {
    padding: 16px 12px 12px 12px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        .group {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          .entryType {
            background-color: #FF652A;
            color: #FFFFFF;
            border-radius: 2px;
            display: inline-block;
            height: 20px;
            width: 32px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }

          .group-name {
            font-size: 16px;
            height: 20px;
            color: #333333;
          }
        }

        .row {
          display: flex;
          padding: 5px 0;

          .base-box {
            width: 20px;
            height: 20px;
            background-color: #FBEFEA;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info {
            font-size: 12px;
            color: #8C8C8C;
          }

          .col {
            display: flex;
            height: 20px;
            width: 82px;
            line-height: 20px;

            .icon {
              width: 20px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background-color: #1565FC;
              font-size: 12px;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
      }

      .right {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .line {
      margin: 12px 0;
      height: 1px;
      background-color: #F3F3F3;
    }

    .bottom1 {
      .row {
        display: flex;
        justify-content: space-between;

        .base-box {
          width: 20px;
          height: 20px;
          background-color: #FBEFEA;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .info {
          font-size: 12px;
          color: #8C8C8C;
        }

        .col {
          display: flex;
          height: 20px;
          line-height: 20px;

          .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: #1565FC;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
          }

          .price {
            height: 20px;
            width: 68px;
            text-align: center;
            line-height: 20px;
            background-color: #E5EDFF;
            font-size: 12px;
            font-weight: 500;
            color: #1565FC;
            border-radius: 0 3px 3px 0;
          }

          .num {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }
  .title-info {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background-color: #fff;
    .title-info-logo {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      background: #e8e8e8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title-info-right {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
    }
    .row {
      font-size: 13px;
      color: #606266;
      line-height: 20px;
      margin-top: 6px;
      &:first-child {
        margin-top: 0;
      }
    }
    .row-name {
      font-size: 15px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
    }
    .row-group {
      color: #606266;
    }
    .row-count,
    .row-fee {
      color: #606266;
    }
  }

  .signup-notice-bar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #FFC60A;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    .notice-icon {
      flex-shrink: 0;
      margin-right: 8px;
      font-size: 16px;
    }
    .notice-text {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .notice-link {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  .title {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    color: #909399;
    background-color: #F6F6F6;
    padding-left: 15px;
  }

  .clotheses {
    padding: 12px 16px;
    overflow-x: auto;
    white-space: nowrap;

    .clothes {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 60px;
      margin-right: 8px;
      border-radius: 4px;
      background-color: #DFDFDF;
      box-sizing: border-box;

      .img {
        width: 60px;
        height: 60px;
      }

      .disabled {
        position: absolute;
        top: 0;
        width: 60px;
        height: 60px;
        border-radius: 4px;
        background-color: #000000;
        opacity: 0.3;
        display: flex;
        align-items: center;
        justify-content: center;

        .lock {
          width: 16px;
          height: 16px;
        }
      }
    }

    .selected {
      box-sizing: border-box;
      box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, .3);
    }
  }

  .bottom-explanation {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .bottom-explanation-title {
      font-weight: bold;
      font-size: 15px;
      color: #1d2129;
      margin-bottom: 8px;
    }
    .bottom-explanation-content {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
      &::v-deep ul {
        margin: 0;
        padding-left: 20px;
      }
      &::v-deep li {
        margin-bottom: 4px;
      }
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
.register{
  .choice-team{
    min-height: 129px;
    border-radius: 5px;
    background: #FFFFFF;
    padding: 12px 0px;
    box-sizing: border-box;
  }
  .choice-btn{
    margin: 20px auto;
    width: 142px;
    height: 39px;
    border-radius: 115px;
    background: #F7F7F7;
    text-align: center;
    line-height: 39px;
    font-size: 14px;
    color: #337ECC;
  }
}

.agreement-top {
  background-color: #fff;
  padding: 12px 12px 0 12px;

  .agreement-title {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    white-space: pre-wrap;
    height: 40vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

::v-deep .van-cell{
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}
::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control{
  font-weight: 500;
}
::v-deep .van-uploader{
  width: 100% !important;
}
::v-deep .van-uploader__wrapper{
  display: block;
}
.my-field{
  width: 100%;
  .class-logo{
    width: 100%;
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    .img{
      width: 48px;
      height: 48px;
      border-radius: 24px;
      background: #D8D8D8;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .logo-info{
      margin-left: 8px;
      flex: 1;
      .title2{
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.9);
      }
      .desc{
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .icon{
      color: #BDBDBD;
      font-size: 24px;
    }
  }
}
</style>
